import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaCalendarAlt, FaUsers, FaBed, FaSearch } from 'react-icons/fa';
import { useBooking } from '../../context/BookingContext';
import './BookingForm.css';

const today = new Date().toISOString().split('T')[0];
const tomorrow = new Date(Date.now() + 86400000).toISOString().split('T')[0];

export default function BookingForm({ compact = false }) {
  const navigate = useNavigate();
  const { updateBooking } = useBooking();
  const [form, setForm] = useState({
    checkIn: today,
    checkOut: tomorrow,
    guests: 2,
    rooms: 1,
    roomType: 'any',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    updateBooking(form);
    navigate('/booking', { state: form });
  };

  return (
    <form className={`booking-form ${compact ? 'booking-form--compact' : ''}`} onSubmit={handleSubmit}>
      {!compact && (
        <div className="booking-form-header">
          <h3>Reserve Your Stay</h3>
          <p>Best rate guaranteed · No hidden fees</p>
        </div>
      )}

      <div className="booking-form-fields">
        <div className="form-field">
          <label><FaCalendarAlt /> Check-In</label>
          <input
            type="date"
            name="checkIn"
            value={form.checkIn}
            min={today}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-field">
          <label><FaCalendarAlt /> Check-Out</label>
          <input
            type="date"
            name="checkOut"
            value={form.checkOut}
            min={form.checkIn || today}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-field">
          <label><FaUsers /> Guests</label>
          <select name="guests" value={form.guests} onChange={handleChange}>
            {[1, 2, 3, 4, 5, 6].map(n => (
              <option key={n} value={n}>{n} Guest{n > 1 ? 's' : ''}</option>
            ))}
          </select>
        </div>

        <div className="form-field">
          <label><FaBed /> Room Type</label>
          <select name="roomType" value={form.roomType} onChange={handleChange}>
            <option value="any">Any Room</option>
            <option value="classic">Classic</option>
            <option value="deluxe">Deluxe</option>
            <option value="superior">Superior</option>
            <option value="suite">Suite</option>
          </select>
        </div>

        <div className="form-field">
          <label><FaBed /> Rooms</label>
          <select name="rooms" value={form.rooms} onChange={handleChange}>
            {[1, 2, 3, 4].map(n => (
              <option key={n} value={n}>{n} Room{n > 1 ? 's' : ''}</option>
            ))}
          </select>
        </div>

        <button type="submit" className="booking-submit-btn">
          <FaSearch />
          <span>Check Availability</span>
        </button>
      </div>
    </form>
  );
}
